/**
 * Canonical billing operational API paths — both shells MUST use these (no UI-specific variants).
 */
export const BILLING_API_ROOT = '/api/v1/billing';

export const BILLING_OPERATIONAL_API = {
  OP_COUNTER: `${BILLING_API_ROOT}/op-counter`,
  COUNTER: `${BILLING_API_ROOT}/counter`,
  OPERATIONS_DESK: `${BILLING_API_ROOT}/op-counter/operations-desk`,
  PATIENT_JOURNEY: `${BILLING_API_ROOT}/patient-journey`,
  IP_DISCHARGE: `${BILLING_API_ROOT}/ip-discharge`,
  SHIFT_CONTINUITY: `${BILLING_API_ROOT}/shift-continuity`,
  OPERATIONAL_ALERTS: `${BILLING_API_ROOT}/operational-alerts`,
  OPERATIONAL_RECOVERY: `${BILLING_API_ROOT}/operational-recovery`,
  OPERATIONAL_READINESS: `${BILLING_API_ROOT}/operational-readiness`,
  REFUND_REVIEW: `${BILLING_API_ROOT}/refund-review`,
  DAY_CLOSE: `${BILLING_API_ROOT}/day-close`,
  FINANCE_CLOSE: `${BILLING_API_ROOT}/finance-close`,
};

/** Lab / radiology / pharmacy integration bases (read-only journey slices). */
export const CLINICAL_API = {
  RECOMMENDATIONS: '/api/v1/clinical/recommendations',
  INVESTIGATION_CATALOG: '/api/v1/clinical/investigation-catalog',
  PHARMACY_MEDICINES: '/api/v1/clinical/pharmacy-medicines',
};

export const MODULE_INTEGRATION_API = {
  LAB_PATIENT_JOURNEY: '/api/v1/lab/integration/patient-journey',
  LAB_QUEUE_PATIENT_IDS: '/api/v1/lab/integration/queue-patient-ids',
  RADIOLOGY_PATIENT_JOURNEY: '/api/v1/radiology/integration/patient-journey',
  RADIOLOGY_QUEUE_PATIENT_IDS: '/api/v1/radiology/integration/queue-patient-ids',
  PHARMACY_PATIENT_JOURNEY: '/api/v1/pharmacy/integration/patient-journey',
  PHARMACY_QUEUE_PATIENT_IDS: '/api/v1/pharmacy/integration/queue-patient-ids',
  CLINICAL_OPERATIONAL_ALERTS: '/api/v1/clinical/integration/operational-alerts',
};

export function withAppsCode(path, appsCode, extraParams = {}) {
  const params = new URLSearchParams({ appsCode, ...extraParams });
  return `${path}?${params}`;
}
